export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-asterisk-83c8112859c3d668373b50886138a9c8.svg";